import { IDynamicForm } from "config";
import { logout } from "store/actions/authentication";
import { dismissDynamicFormModal, fetchDynamicForm, initFormFlow } from "store/actions/flow";

import { createReducer, isAllOf, PayloadAction } from "@reduxjs/toolkit";

const defaultState: IDynamicForm = {
  description: "",
  expiration: undefined,
  flow: { slug: "" },
  id: "",
  groups: [],
  items: [],
  layout: "vertical",
  leadingNavigationButton: undefined,
  slug: "",
};

/* ------------------    ADD MATCHERS     ------------------ */

const isDynamicFormModalLayout = (
  action: PayloadAction<IDynamicForm>
): action is PayloadAction<IDynamicForm> => {
  return action.payload?.layout === "modal";
};

const isDynamicFormModalFulfilled = isAllOf(fetchDynamicForm.fulfilled, isDynamicFormModalLayout);

/* ------------------    REDUCER     ------------------ */
const dynamicFormModal = createReducer(defaultState, builder => {
  builder
    .addCase(dismissDynamicFormModal.type, () => {
      return defaultState;
    })
    .addCase(initFormFlow.pending, () => defaultState)
    .addCase(logout, () => defaultState)
    .addMatcher(isDynamicFormModalFulfilled, (state, action) => {
      const dynamicForm = action.payload;

      state.description = dynamicForm.description;
      state.flow = dynamicForm.flow;
      state.id = dynamicForm.id;
      state.groups = dynamicForm.groups || [];
      state.items = dynamicForm.items;
      state.layout = dynamicForm.layout;
      state.leadingNavigationButton = dynamicForm.leadingNavigationButton;
      state.slug = dynamicForm.slug;
    });
});

export default dynamicFormModal;
